// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimsSubstantiationRateMetricsResponseDto
 */
export interface IClaimsSubstantiationRateMetricsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IClaimsSubstantiationRateMetricsResponseDto
     */
    ytd?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimsSubstantiationRateMetricsResponseDto
     */
    thirty_days?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimsSubstantiationRateMetricsResponseDto
     */
    ninety_days?: number;
}

/**
 * Check if a given object implements the IClaimsSubstantiationRateMetricsResponseDto interface.
 */
export function instanceOfIClaimsSubstantiationRateMetricsResponseDto(value: object): value is IClaimsSubstantiationRateMetricsResponseDto {
    return true;
}

export function IClaimsSubstantiationRateMetricsResponseDtoFromJSON(json: any): IClaimsSubstantiationRateMetricsResponseDto {
    return IClaimsSubstantiationRateMetricsResponseDtoFromJSONTyped(json, false);
}

export function IClaimsSubstantiationRateMetricsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimsSubstantiationRateMetricsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'ytd': json['ytd'] == null ? undefined : json['ytd'],
        'thirty_days': json['thirty_days'] == null ? undefined : json['thirty_days'],
        'ninety_days': json['ninety_days'] == null ? undefined : json['ninety_days'],
    };
}

export function IClaimsSubstantiationRateMetricsResponseDtoToJSON(json: any): IClaimsSubstantiationRateMetricsResponseDto {
    return IClaimsSubstantiationRateMetricsResponseDtoToJSONTyped(json, false);
}

export function IClaimsSubstantiationRateMetricsResponseDtoToJSONTyped(value?: IClaimsSubstantiationRateMetricsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ytd': value['ytd'],
        'thirty_days': value['thirty_days'],
        'ninety_days': value['ninety_days'],
    };
}

